/**
 * PgM navigation helpers — persist the last Program / release-workspace location so
 * sidebar "Program" returns to where the operator left off (project filter, release, tab).
 */

const STORAGE_KEY = 'fluent.pgm.lastPath';

export function savePgmPath(pathname: string, search = ''): void {
  if (!pathname.startsWith('/pgm')) return;
  if (pathname === '/pgm/discovery' || pathname.startsWith('/pgm/discovery/')) return;
  try {
    sessionStorage.setItem(STORAGE_KEY, `${pathname}${search}`);
  } catch {
    // sessionStorage unavailable (private mode quota, etc.) — ignore
  }
}

/** Last visited `/pgm*` path, or `/pgm` when none saved. */
export function getPgmNavPath(): string {
  try {
    const saved = sessionStorage.getItem(STORAGE_KEY);
    if (saved && saved.startsWith('/pgm')) return saved;
  } catch {
    // ignore
  }
  return '/pgm';
}

export function buildReleaseWorkspacePath(
  releaseId: string,
  opts?: { tab?: string; project?: string | null },
): string {
  const params = new URLSearchParams();
  if (opts?.tab) params.set('tab', opts.tab);
  if (opts?.project) params.set('project', opts.project);
  const q = params.toString();
  return `/pgm/releases/${releaseId}${q ? `?${q}` : ''}`;
}

export function buildProgramPath(projectId?: string | null): string {
  if (!projectId) return '/pgm';
  return `/pgm?project=${encodeURIComponent(projectId)}`;
}

export function buildDiscoveryPath(projectId?: string | null): string {
  if (!projectId) return '/pgm/discovery';
  return `/pgm/discovery?project=${encodeURIComponent(projectId)}`;
}
